export default __webpack_public_path__ + "static/media/art.221639ca.svg";